import { Array } from "@siteimprove/alfa-array";
import { Parser } from "@siteimprove/alfa-parser";
import { Function, Token, } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { LengthPercentage } from "../numeric/index.js";
import { Value } from "../value.js";
import { BasicShape } from "./basic-shape.js";
const { left, map, option, pair, right, separated, separatedList } = Parser;
const { parseComma, parseWhitespace } = Token;
/**
 * {@link https://drafts.csswg.org/css-shapes/#funcdef-polygon}
 *
 * @public
 */
export class Polygon extends BasicShape {
    static of(fill, vertices) {
        return new Polygon(fill, Array.from(vertices));
    }
    _fill;
    _vertices;
    constructor(fill, vertices) {
        super("polygon", vertices.reduce((calc, vertex) => calc || Value.hasCalculation(...vertex), false));
        this._fill = fill;
        this._vertices = vertices;
    }
    get fill() {
        return this._fill;
    }
    get vertices() {
        return this._vertices;
    }
    resolve(resolver) {
        return new Polygon(this._fill, this._vertices.map((vertex) => 
        // map loses the fact that vertex has exactly two elements.
        vertex.map(LengthPercentage.resolve(resolver))));
    }
    partiallyResolve(resolver) {
        return new Polygon(this._fill, this._vertices.map((vertex) => 
        // map loses the fact that vertex has exactly two elements.
        vertex.map(LengthPercentage.partiallyResolve(resolver))));
    }
    equals(value) {
        return (value instanceof Polygon &&
            value._fill.equals(this._fill) &&
            Array.equals(value._vertices, this._vertices));
    }
    hash(hash) {
        hash.writeHashable(this._fill);
        Array.hash(this._vertices, hash);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            fill: this._fill.toJSON(),
            vertices: Array.toJSON(this._vertices),
        };
    }
    toString() {
        const fill = this._fill.reduce((_, fill) => `${fill}, `, "");
        const vertices = this._vertices.map(([h, v]) => `${h} ${v}`).join(" ");
        return `polygon(${fill}${vertices})`;
    }
}
/**
 * @public
 */
(function (Polygon) {
    function isPolygon(value) {
        return value instanceof Polygon;
    }
    Polygon.isPolygon = isPolygon;
    const parseVertex = separated(LengthPercentage.parse, parseWhitespace, LengthPercentage.parse);
    Polygon.parse = map(Function.parse("polygon", pair(option(left(Keyword.parse("nonzero", "evenodd"), parseComma)), right(option(parseWhitespace), separatedList(parseVertex, parseWhitespace)))), ([_, [fill, vertices]]) => Polygon.of(fill, vertices));
})(Polygon || (Polygon = {}));
//# sourceMappingURL=polygon.js.map